(() => {
  const WORD_LIMIT = 7;
  const MOBILE_MAX = 768;

  // Πιάνει και title container και link, ό,τι υπάρχει
  const SELECTORS = [
    ".xo-product-card__title",
    ".xo-product-card__title a",
    "[data-product-card-title]",
    ".product-card__title",
    ".product-card__title a",
  ];

  function getTitleNodes() {
    const set = new Set();
    SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => set.add(el));
    });
    return Array.from(set);
  }

  function truncateEl(el) {
    if (!el) return;

    // Μην πειράζεις στοιχεία που έχουν παιδιά/δομή (π.χ. spans/icons) — πάμε στο πιο “texty” node
    // Αν είναι container που έχει link μέσα, προτίμησε το link
    const link = el.querySelector?.("a");
    const node = link || el;

    if (!node.dataset.fullTitle) {
      node.dataset.fullTitle = (node.textContent || "").trim();
    }

    const full = node.dataset.fullTitle;

    if (window.innerWidth > MOBILE_MAX) {
      if (node.textContent !== full) node.textContent = full;
      return;
    }

    const words = full.split(/\s+/).filter(Boolean);
    if (words.length <= WORD_LIMIT) {
      if (node.textContent !== full) node.textContent = full;
      return;
    }

    const truncated = words.slice(0, WORD_LIMIT).join(" ") + "…";
    if (node.textContent !== truncated) node.textContent = truncated;
  }

  function run() {
    getTitleNodes().forEach(truncateEl);
  }

  // initial
  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", () => setTimeout(run, 200));

  // resize debounce
  let r;
  window.addEventListener("resize", () => {
    clearTimeout(r);
    r = setTimeout(run, 120);
  });

  // ✅ KEY PART: επειδή το carousel κάνει render/lazy, τρέξε για λίγα δευτερόλεπτα και σταμάτα
  function burstRun(ms = 3500, step = 250) {
    run();
    const id = setInterval(run, step);
    setTimeout(() => clearInterval(id), ms);
  }

  document.addEventListener("shopify:section:load", () => burstRun());
  document.addEventListener("touchend", () => burstRun(1200, 250), { passive: true });
  document.addEventListener("scroll", () => {
    clearTimeout(window.__ttScroll);
    window.__ttScroll = setTimeout(() => burstRun(1200, 250), 150);
  }, { passive: true });

  // και ένα burst στην αρχή
  burstRun();
})();
